const projects = {
    pageShield: {
        img: require("../assets/pageshield.jpeg"),
        name: 'PageShield',
        title: 'PageShield - ADM',
        description: "PageShield is a web application that manages Facebook Pages by using AI to hide negative comments. Working under ADM, I was able to create the Frontend of this web-app using ReactJS while using Facebook API and Stripe's component library for user onboarding and purchases."
    },
    // bosawasUI: {
    //     img: require("../assets/bosawas-ui.jpeg"),
    //     name: 'Bosawas',
    //     title: 'Bosawas UI - Personal Project',
    //     description: "Bosawas UI, named after Nicaragua's largest nature reserve, is an Open-Source design system created to simplify the development of React applications. This design system is being developed using ReactJS and Storybook, and undergoing structural testing using Jest."
    // }, 
    hercules: {
        img: require("../assets/hercules.jpeg"),
        name: 'Hercules',
        title: 'Hercules - ADM',
        description: 'Hercules is a Facebook marketing tool that predicted the performance of campaigns. In this project, other than creating the entire Frontend, I was responsible for maintaining the RESTful API in the Backend SDK using Python, NodeJS, and MySQL.'
    }, 
    roomEscape: {
        img: require("../assets/room-escape.jpeg"),
        name: 'Room Escape',
        title: 'Room Escape - Personal Project',
        description: 'Room Escape is a first person shooter puzzle game that I created using C++ and Unreal Engine 4.'
    },
    assuranceMezz: {
        img: require("../assets/assurancemezz.png"),
        name: 'Assurance',
        title: 'Assurance Mezzanine Fund - Freelance',
        description: 'I was hired to redesign and ship the webpage for a private investment firm. Using React and EmailJS I built the webpage from scrap and implemented a direct messaging module for feedback and contacting purpose.',
        link: 'https://www.assurancemezz.com'
    },
    partnrup: {
        img: require('../assets/scale.png'),
        name: 'Scale',
        title: 'Scale - Personal Project',
        description: 'Scale is an application aimed towards helping college students better understand the concepts of cash flow and budgeting. The backend of this application is a RESTful API built using Golang and Plaid API to connect to user financial info and is hosted in AWS. The frontend is being developed in Expo, a framework pertaining to React-Native that allows singe-codebase native development. Both projects are publically availble on github.com',
        link: "https://www.github.com/elopez00"
    }
}

export default projects;